import { AnimatePresence, motion } from 'framer-motion';
import { useTargetScoreRangeGraphic } from '..';
import { EditTargetScoreRangeModal, Tooltip } from '../..';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useElementsEnvironmentContext } from '../../../../';

export function TargetScoreRangeGraphic() {
  const {
    firmID,
    element,
    firmClientID,
    minLeftStyle,
    showIndicator,
    isMinimumWidth,
    derivedWidthStyle,
    indicatorScaleUpFactor,
    indicatorScaleDownFactor,
    showEditTargetScoreRangeModal,
    setShowEditTargetScoreRangeModal,
    isTargetRangeEditable,
  } = useTargetScoreRangeGraphic();
  const { t: tTargetScore } = useTranslation('targetScore');
  const [isHovered, setIsHovered] = useState(false);
  const showTooltip = isHovered && !showEditTargetScoreRangeModal;
  const { app } = useElementsEnvironmentContext();

  return app === 'advisor' ? (
    <>
      <AnimatePresence>
        {showIndicator && (
          <motion.div
            layout
            exit={{ scale: 0, opacity: 0 }}
            animate={{
              scale: 1,
              opacity: 1,
              left: minLeftStyle,
              width: derivedWidthStyle,
              transition: { ease: 'easeInOut' },
            }}
            whileHover={{ scale: indicatorScaleUpFactor }}
            whileTap={{ scale: indicatorScaleDownFactor }}
            layoutId={`target-score-range-indicator-${element}`}
            initial={{ scale: 0, opacity: 0, left: 0, width: 0 }}
            onClick={isTargetRangeEditable ? () => setShowEditTargetScoreRangeModal(true) : () => {}}
            transformTemplate={(_, ogTransform) => (isMinimumWidth ? `${ogTransform} translateX(-50%)` : ogTransform)}
            className="absolute z-10 pointer-events-none inset-y-0 h-2 m-auto min-w-2"
          >
            <Tooltip
              offset={[0, 10]}
              placement="bottom"
              show={showTooltip}
              floatingElement={
                <div className="!w-[163px] !h-[30px] shadow-classic pt-2 text-center text-white text-xs bg-darkMode-gray-dropdown rounded">
                  {tTargetScore('edit-target-score-tooltip')}
                </div>
              }
            >
              <motion.div
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                data-is-editable={isTargetRangeEditable}
                className="pointer-events-auto h-full w-full bg-palette-600 rounded-full hover:shadow-classic data-[is-editable=true]:cursor-pointer"
              />
            </Tooltip>
          </motion.div>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {showEditTargetScoreRangeModal && (
          <EditTargetScoreRangeModal
            firmID={firmID}
            element={element}
            firmClientID={firmClientID}
            closeModal={() => setShowEditTargetScoreRangeModal(false)}
          />
        )}
      </AnimatePresence>
    </>
  ) : (
    <>
      {showIndicator && (
        <div
          style={{
            left: minLeftStyle,
            width: derivedWidthStyle,
          }}
          className="absolute z-10 pointer-events-none inset-y-0 h-2 m-auto min-w-2"
        >
          <div className="pointer-events-auto h-full w-full bg-palette-600 rounded-full hover:shadow-classic data-[is-editable=true]:cursor-pointer" />
        </div>
      )}
    </>
  );
}
